export default {
  pendingDealOfferAction: null,
  appliedDealRowUpdate: null,
};
